import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 替换主题色
import '@/assets/css/theme/index.css'

Vue.use(ElementUI)
